































import { Component, Vue, Prop, Ref, Emit } from 'vue-property-decorator';
import { ModalEvents } from '../../consts';

@Component
export default class ModalQuestion extends Vue {
  @Prop({ type: String, required: true }) title;
  @Prop({ type: String, required: true }) readonly question;
  @Prop({ type: String, required: false, default: '' }) questionClass;
  @Prop({ type: String, required: false, default: '' }) titleClass;
  @Prop({ type: String, required: false, default: 'md' }) size;

  private show = false;
  private dataObj = null;

  questionValue = '';

  @Emit()
  modalClose() {
    return 1;
  }

  showModal(dataObj: any) {
    this.dataObj = dataObj;
    this.show = true;
  }
  saveModal() {
    console.log('Emit dataObj', this.dataObj);
    this.$emit(ModalEvents.OK_EVENT, this.dataObj);
    this.show = false;
  }
  hideModal() {
    this.$emit(ModalEvents.CANCEL_EVENT);
    this.show = false;
  }
}
